// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/icons/filter-list.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.items-page {
  --items-bg: #f4f7f7;
  --items-surface: #ffffff;
  --items-surface-muted: #f4f7f7;
  --items-border: #dce3e2;
  --items-border-strong: #cdd6d4;
  --items-text: #142624;
  --items-muted: #506360;
  --items-brand: #0f766e;
  --items-brand-hover: #0a655f;
  min-height: 100vh;
  display: flex;
  background: var(--items-bg);
  color: var(--items-text);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-weight: var(--font-weight-regular, 400);
  line-height: 20.2px;
  letter-spacing: 0;
}

.items-page.dark {
  --items-bg: #101113;
  --items-surface: #191b1f;
  --items-surface-muted: #22252a;
  --items-border: #2c3036;
  --items-border-strong: #3a3f47;
  --items-text: #f2f3f5;
  --items-muted: #b3b8c2;
  --items-brand: #43a79c;
  --items-brand-hover: #83c7be;
}

.items-page *,
.items-page *::before,
.items-page *::after {
  box-sizing: border-box;
}

.items-page .items-main {
  flex: 1 1;
  min-width: 0;
  margin-left: 256px;
  display: flex;
  flex-direction: column;
}

.items-content {
  width: 100%;
  min-height: calc(100vh - 64px);
  padding: 32px 32px 48px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.items-compact-org {
  display: none;
}

.items-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.items-page-header h1 {
  margin: 0;
  color: var(--items-text);
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.48px;
}

.items-page-header p {
  margin: 4px 0 0;
  color: var(--items-muted);
  font-size: 14px;
  font-weight: var(--font-weight-regular, 400);
  line-height: 21.7px;
  letter-spacing: 0;
}

.items-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.items-import-button,
.items-add-button {
  height: 40px;
  padding: 0 13px;
  border-radius: 10px;
  font: var(--font-weight-medium, 500) 13px / normal
    var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
}

.items-import-button {
  color: var(--items-text);
  background: var(--items-surface);
  border: 1px solid var(--items-border-strong);
}

.items-import-button:hover {
  background: var(--items-surface-muted);
}

.items-add-button,
.items-add-button:link,
.items-add-button:visited {
  color: #ffffff !important;
  background: var(--items-brand);
  border: 1px solid var(--items-brand);
}

.items-add-button:hover {
  color: #ffffff !important;
  background: var(--items-brand-hover);
}

.items-add-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.items-add-button svg {
  width: 16px;
  height: 16px;
  stroke-width: 2;
}

.items-workspace {
  min-width: 0;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  gap: 16px;
}

.items-tabs {
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid var(--items-border);
}

.items-tabs button {
  height: 40px;
  padding: 0 12px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: var(--items-muted);
  font: var(--font-weight-medium, 500) 13px/16.9px
    var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: 0.065px;
  cursor: pointer;
  margin-bottom: -1px;
  transition: color 0.15s ease;
}

.items-tabs button:hover,
.items-tabs button.active {
  color: var(--items-brand);
}

.items-tabs button.active {
  border-bottom-color: var(--items-brand);
}

.items-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.items-search {
  width: min(100%, 330px);
  height: 40px;
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 0 12px;
  color: var(--items-muted);
  background: var(--items-surface);
  border: 1px solid var(--items-border-strong);
  border-radius: 10px;
}

.items-search:focus-within {
  border-color: var(--items-brand);
  box-shadow: none;
}

.items-search svg {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
}

.items-search input {
  width: 100%;
  min-width: 0;
  padding: 0;
  border: 0;
  outline: 0;
  color: var(--items-text);
  background: transparent;
  font: var(--font-weight-regular, 400) 14px / normal
    var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: 0;
}

.items-search input::placeholder {
  color: #73827f;
}

.items-filter-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.items-page .items-filter-button {
  min-width: 88px;
  height: 40px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid var(--items-border);
  border-radius: 10px;
  background: var(--items-surface);
  color: var(--items-text);
  font: var(--font-weight-medium, 500) 13px / normal
    var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: 0;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.items-page .items-filter-button:hover,
.items-page .items-filter-button.active {
  background: var(--items-surface-muted);
  border-color: var(--items-border-strong);
  color: var(--items-text);
}

.items-filter-icon {
  display: block;
  flex: 0 0 16px;
  width: 16px;
  height: 16px;
  background: currentColor;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / contain no-repeat;
}

.items-filter-panel {
  position: absolute;
  z-index: 20;
  top: calc(100% + 8px);
  left: 0;
  width: 270px;
  padding: 16px;
  display: grid;
  gap: 14px;
  border: 1px solid var(--items-border);
  border-radius: 12px;
  background: var(--items-surface);
  box-shadow: 0 12px 30px rgba(20, 38, 36, 0.14);
}

.items-filter-field {
  display: grid;
  gap: 7px;
  color: var(--items-muted);
  font-size: 12px;
  font-weight: 500;
}

.items-filter-select {
  flex: 0 0 134px;
  width: 134px;
  min-width: 134px;
  max-width: 134px;
}

.items-filter-select .quotation-figma-dropdown-trigger {
  height: 40px;
  padding: 0 12px;
  border: 1px solid var(--items-border-strong);
  border-radius: var(--radius-md, 10px);
  background: var(--items-surface);
  color: var(--items-text);
  font: var(--font-weight-medium, 500) 13px/20px
    var(--font-family-primary, "Lexend", sans-serif);
  outline: none;
}

.items-filter-select .quotation-figma-dropdown-trigger:hover {
  border-color: var(--border-strong);
}

.items-filter-select.is-open .quotation-figma-dropdown-trigger,
.items-filter-select .quotation-figma-dropdown-trigger:focus-visible {
  border-width: 1px;
  border-color: var(--items-brand);
  box-shadow: none;
}

.items-filter-select .quotation-figma-dropdown-trigger svg {
  transition: transform var(--duration-fast, 100ms) var(--easing-out, ease-out);
}

.items-filter-select.is-open .quotation-figma-dropdown-trigger svg {
  transform: rotate(180deg);
}

.items-filter-select .quotation-figma-dropdown-menu {
  max-height: 240px;
  overflow-x: hidden;
  overflow-y: auto;
}

.items-table-card {
  margin-top: 8px;
  overflow: hidden;
  border: 1px solid var(--items-border);
  border-radius: 14px;
  background: var(--items-surface);
  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);
  display: flex;
  flex-direction: column;
}

.items-table-toolbar {
  min-height: 52px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid var(--items-border);
}

.items-table-toolbar strong {
  color: var(--items-text);
  font-size: 13px;
  font-weight: var(--font-weight-medium, 500);
  line-height: 16.9px;
  letter-spacing: 0.065px;
}

.items-sort,
.items-delete-selected {
  padding: 6px 8px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: transparent;
  color: var(--items-muted);
  font: var(--font-weight-regular, 400) 13px/18.2px
    var(--font-family-primary, "Lexend", sans-serif);
  letter-spacing: 0.065px;
  cursor: pointer;
}

.items-sort:hover {
  color: var(--items-brand);
}

.items-delete-selected {
  color: #a3301f;
  font-weight: 500;
}

.items-table-scroll {
  overflow-x: auto;
}

.items-table {
  width: 100%;
  min-width: 830px;
  border-collapse: collapse;
  table-layout: fixed;
}

.items-table th,
.items-table td {
  padding: 8px 12px;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid var(--items-border);
}

.items-skeleton-row:hover {
  background: transparent !important;
}

.items-skeleton-name {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.items-skeleton-price {
  margin-left: auto;
}

.items-table th {
  height: 44px;
  background: var(--items-surface-muted);
  color: var(--items-muted);
  font-size: 13px;
  font-weight: var(--font-weight-medium, 500);
  line-height: 16.9px;
  letter-spacing: 0.065px;
}

.items-table td {
  height: 64px;
  color: var(--items-text);
  font-size: 13px;
  font-weight: var(--font-weight-regular, 400);
  line-height: 20.2px;
  letter-spacing: 0;
}

.items-table tbody tr:hover,
.items-table tbody tr.selected {
  background: #f0f8f7;
}

.items-page.dark .items-table tbody tr:hover,
.items-page.dark .items-table tbody tr.selected {
  background: #1b302e;
}

.items-table th:nth-child(1) {
  width: 34px;
}

.items-table th:nth-child(2) {
  width: 110px;
}

.items-table th:nth-child(3) {
  width: 24%;
}

.items-table th:nth-child(4),
.items-table th:nth-child(5),
.items-table th:nth-child(6) {
  width: 12%;
}

.items-table th:nth-child(7) {
  width: 15%;
}

.items-table th:nth-child(8) {
  width: 78px;
}

.items-check-cell {
  padding-left: 12px !important;
  padding-right: 2px !important;
  text-align: center !important;
}

.items-check-cell input {
  width: 14px;
  height: 14px;
  margin: 0;
  accent-color: var(--items-brand);
  cursor: pointer;
}

.items-code-link,
.items-code-link:link,
.items-code-link:visited {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--items-brand);
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
  font-size: 14px;
  font-weight: var(--font-weight-medium, 500);
  line-height: 18.2px;
  letter-spacing: 0.28px;
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
}

.items-code-link:hover {
  color: var(--items-brand-hover);
  text-decoration: underline;
}

.items-code-link,
.items-name,
.items-description {
  display: block;
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: left;
}

.items-name {
  color: var(--items-text);
  font-size: 13px;
  font-weight: var(--font-weight-regular, 400);
  line-height: 20.2px;
  letter-spacing: 0;
}

.items-description {
  margin-top: 0;
  color: var(--items-muted);
  font-size: 11px;
  font-weight: var(--font-weight-regular, 400);
  line-height: 15.4px;
  letter-spacing: 0.11px;
}

.items-status {
  min-height: 20px;
  padding: 3px 7px;
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  font-size: 11px;
  font-weight: var(--font-weight-medium, 500);
  line-height: 14.3px;
  letter-spacing: 0.11px;
}

.items-status-active {
  color: #115a33;
  background: #edfbf2;
}

.items-status-inactive,
.items-status-archived {
  color: #a3301f;
  background: #fef2f1;
}

.items-page.dark .items-status-active {
  color: #8cd2b2;
  background: #1b332b;
}

.items-page.dark .items-status-inactive,
.items-page.dark .items-status-archived {
  color: #f3a6a1;
  background: #382324;
}

.items-price-cell {
  text-align: right !important;
}

.items-table td.items-price-cell {
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
  font-size: 15px;
  font-weight: var(--font-weight-medium, 500);
  line-height: 19.5px;
  letter-spacing: 0;
}

.items-action-cell {
  text-align: center !important;
}

.items-row-menu {
  position: relative;
  display: inline-flex;
}

.items-row-menu > button {
  width: 30px;
  height: 30px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--items-muted);
  cursor: pointer;
}

.items-row-menu > button:hover {
  color: var(--items-text);
  background: var(--items-surface-muted);
}

.items-empty-state {
  height: 140px !important;
  color: var(--items-muted) !important;
  text-align: center !important;
}

.items-pagination {
  min-height: 52px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-top: 1px solid var(--items-border);
  color: var(--items-muted);
  font-size: 13px;
  font-weight: var(--font-weight-regular, 400);
  line-height: normal;
  letter-spacing: 0;
}

.items-pagination > div {
  display: flex;
  gap: 7px;
}

.items-pagination button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--items-border);
  border-radius: 6px;
  background: var(--items-surface);
  color: var(--items-text);
  cursor: pointer;
}

.items-pagination button:hover:not(:disabled) {
  border-color: var(--items-brand);
  color: var(--items-brand);
}

.items-pagination button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

@media (max-width: 1024px) {
  .items-page-header h1 {
    font-size: 28px;
    line-height: 35px;
    letter-spacing: -0.42px;
  }

  .items-page .items-main {
    margin-left: 0;
  }

  .items-content {
    padding: 20px 24px 40px;
  }

  .items-compact-org {
    min-height: 42px;
    margin-bottom: 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .items-compact-org > button {
    width: 34px;
    height: 34px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--items-border);
    border-radius: 8px;
    background: var(--items-surface);
    color: var(--items-text);
  }

  .items-compact-org > span {
    margin-right: auto;
    color: var(--items-text);
    font-weight: 600;
  }

  .items-compact-org > div {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .items-compact-org i {
    width: 30px;
    height: 30px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #eef8f7;
    color: var(--items-brand);
    font-size: 11px;
    font-style: normal;
  }

  .items-compact-org strong,
  .items-compact-org small {
    display: block;
  }

  .items-compact-org strong {
    font-size: 12px;
    font-weight: 500;
  }

  .items-compact-org small {
    margin-top: 1px;
    color: var(--items-muted);
    font-size: 10px;
    font-weight: 400;
  }
}

@media (max-width: 640px) {
  .items-page-header h1 {
    font-size: 24px;
    line-height: 30px;
    letter-spacing: -0.36px;
  }

  .items-content {
    padding: 16px 14px 32px;
  }

  .items-compact-org > div strong,
  .items-compact-org > div > svg {
    display: none;
  }

  .items-page-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .items-header-actions {
    width: 100%;
  }

  .items-import-button,
  .items-add-button {
    flex: 1 1;
  }

  .items-controls {
    align-items: stretch;
    flex-direction: column;
    padding: 12px 0;
  }

  .items-search {
    width: 100%;
  }

  .items-filter-wrap {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }

  .items-filter-select {
    width: 100%;
    min-width: 0;
    max-width: none;
  }

  .items-filter-button {
    width: 100%;
    justify-content: center;
  }

  .items-filter-panel {
    width: min(100vw - 28px, 320px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Items/Items.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,wBAAwB;EACxB,6DAA6D;EAC7D,eAAe;EACf,4CAA4C;EAC5C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,4CAA4C;EAC5C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB;oDACkD;EAClD,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;;EAGE,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,yBAAyB;EACzB;oDACkD;EAClD,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,uBAAuB;EACvB;oDACkD;EAClD,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,qCAAqC;EACrC,mBAAmB;EACnB,gCAAgC;EAChC,wBAAwB;EACxB;oDACkD;EAClD,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;;EAEE,sCAAsC;EACtC,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,wBAAwB;EAGxB,wEAA0E;AAC5E;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,SAAS;EACT,qCAAqC;EACrC,mBAAmB;EACnB,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;EAChC,wBAAwB;EACxB;oDACkD;EAClD,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,gCAAgC;EAChC,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB;oDACkD;EAClD,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,yBAAyB;EACzB,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,4CAA4C;EAC5C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;;EAGE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,iEAAiE;EACjE,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,4CAA4C;EAC5C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,4CAA4C;EAC5C,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iEAAiE;EACjE,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,yCAAyC;EACzC,yBAAyB;EACzB,eAAe;EACf,4CAA4C;EAC5C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,gCAAgC;EAChC,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,kBAAkB;IAClB,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;EACpB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,SAAO;EACT;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,+BAA+B;EACjC;AACF","sourcesContent":[".items-page {\n  --items-bg: #f4f7f7;\n  --items-surface: #ffffff;\n  --items-surface-muted: #f4f7f7;\n  --items-border: #dce3e2;\n  --items-border-strong: #cdd6d4;\n  --items-text: #142624;\n  --items-muted: #506360;\n  --items-brand: #0f766e;\n  --items-brand-hover: #0a655f;\n  min-height: 100vh;\n  display: flex;\n  background: var(--items-bg);\n  color: var(--items-text);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-weight: var(--font-weight-regular, 400);\n  line-height: 20.2px;\n  letter-spacing: 0;\n}\n\n.items-page.dark {\n  --items-bg: #101113;\n  --items-surface: #191b1f;\n  --items-surface-muted: #22252a;\n  --items-border: #2c3036;\n  --items-border-strong: #3a3f47;\n  --items-text: #f2f3f5;\n  --items-muted: #b3b8c2;\n  --items-brand: #43a79c;\n  --items-brand-hover: #83c7be;\n}\n\n.items-page *,\n.items-page *::before,\n.items-page *::after {\n  box-sizing: border-box;\n}\n\n.items-page .items-main {\n  flex: 1;\n  min-width: 0;\n  margin-left: 256px;\n  display: flex;\n  flex-direction: column;\n}\n\n.items-content {\n  width: 100%;\n  min-height: calc(100vh - 64px);\n  padding: 32px 32px 48px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.items-compact-org {\n  display: none;\n}\n\n.items-page-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.items-page-header h1 {\n  margin: 0;\n  color: var(--items-text);\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 40px;\n  letter-spacing: -0.48px;\n}\n\n.items-page-header p {\n  margin: 4px 0 0;\n  color: var(--items-muted);\n  font-size: 14px;\n  font-weight: var(--font-weight-regular, 400);\n  line-height: 21.7px;\n  letter-spacing: 0;\n}\n\n.items-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.items-import-button,\n.items-add-button {\n  height: 40px;\n  padding: 0 13px;\n  border-radius: 10px;\n  font: var(--font-weight-medium, 500) 13px / normal\n    var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  white-space: nowrap;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.items-import-button {\n  color: var(--items-text);\n  background: var(--items-surface);\n  border: 1px solid var(--items-border-strong);\n}\n\n.items-import-button:hover {\n  background: var(--items-surface-muted);\n}\n\n.items-add-button,\n.items-add-button:link,\n.items-add-button:visited {\n  color: #ffffff !important;\n  background: var(--items-brand);\n  border: 1px solid var(--items-brand);\n}\n\n.items-add-button:hover {\n  color: #ffffff !important;\n  background: var(--items-brand-hover);\n}\n\n.items-add-button:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.items-add-button svg {\n  width: 16px;\n  height: 16px;\n  stroke-width: 2;\n}\n\n.items-workspace {\n  min-width: 0;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.items-tabs {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-bottom: 1px solid var(--items-border);\n}\n\n.items-tabs button {\n  height: 40px;\n  padding: 0 12px;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: var(--items-muted);\n  font: var(--font-weight-medium, 500) 13px/16.9px\n    var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: 0.065px;\n  cursor: pointer;\n  margin-bottom: -1px;\n  transition: color 0.15s ease;\n}\n\n.items-tabs button:hover,\n.items-tabs button.active {\n  color: var(--items-brand);\n}\n\n.items-tabs button.active {\n  border-bottom-color: var(--items-brand);\n}\n\n.items-controls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n\n.items-search {\n  width: min(100%, 330px);\n  height: 40px;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 0 12px;\n  color: var(--items-muted);\n  background: var(--items-surface);\n  border: 1px solid var(--items-border-strong);\n  border-radius: 10px;\n}\n\n.items-search:focus-within {\n  border-color: var(--items-brand);\n  box-shadow: none;\n}\n\n.items-search svg {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 auto;\n}\n\n.items-search input {\n  width: 100%;\n  min-width: 0;\n  padding: 0;\n  border: 0;\n  outline: 0;\n  color: var(--items-text);\n  background: transparent;\n  font: var(--font-weight-regular, 400) 14px / normal\n    var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: 0;\n}\n\n.items-search input::placeholder {\n  color: #73827f;\n}\n\n.items-filter-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.items-page .items-filter-button {\n  min-width: 88px;\n  height: 40px;\n  padding: 0 14px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border: 1px solid var(--items-border);\n  border-radius: 10px;\n  background: var(--items-surface);\n  color: var(--items-text);\n  font: var(--font-weight-medium, 500) 13px / normal\n    var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: 0;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.items-page .items-filter-button:hover,\n.items-page .items-filter-button.active {\n  background: var(--items-surface-muted);\n  border-color: var(--items-border-strong);\n  color: var(--items-text);\n}\n\n.items-filter-icon {\n  display: block;\n  flex: 0 0 16px;\n  width: 16px;\n  height: 16px;\n  background: currentColor;\n  -webkit-mask: url(\"../../assets/icons/filter-list.svg\") center / contain\n    no-repeat;\n  mask: url(\"../../assets/icons/filter-list.svg\") center / contain no-repeat;\n}\n\n.items-filter-panel {\n  position: absolute;\n  z-index: 20;\n  top: calc(100% + 8px);\n  left: 0;\n  width: 270px;\n  padding: 16px;\n  display: grid;\n  gap: 14px;\n  border: 1px solid var(--items-border);\n  border-radius: 12px;\n  background: var(--items-surface);\n  box-shadow: 0 12px 30px rgba(20, 38, 36, 0.14);\n}\n\n.items-filter-field {\n  display: grid;\n  gap: 7px;\n  color: var(--items-muted);\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.items-filter-select {\n  flex: 0 0 134px;\n  width: 134px;\n  min-width: 134px;\n  max-width: 134px;\n}\n\n.items-filter-select .quotation-figma-dropdown-trigger {\n  height: 40px;\n  padding: 0 12px;\n  border: 1px solid var(--items-border-strong);\n  border-radius: var(--radius-md, 10px);\n  background: var(--items-surface);\n  color: var(--items-text);\n  font: var(--font-weight-medium, 500) 13px/20px\n    var(--font-family-primary, \"Lexend\", sans-serif);\n  outline: none;\n}\n\n.items-filter-select .quotation-figma-dropdown-trigger:hover {\n  border-color: var(--border-strong);\n}\n\n.items-filter-select.is-open .quotation-figma-dropdown-trigger,\n.items-filter-select .quotation-figma-dropdown-trigger:focus-visible {\n  border-width: 1px;\n  border-color: var(--items-brand);\n  box-shadow: none;\n}\n\n.items-filter-select .quotation-figma-dropdown-trigger svg {\n  transition: transform var(--duration-fast, 100ms) var(--easing-out, ease-out);\n}\n\n.items-filter-select.is-open .quotation-figma-dropdown-trigger svg {\n  transform: rotate(180deg);\n}\n\n.items-filter-select .quotation-figma-dropdown-menu {\n  max-height: 240px;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.items-table-card {\n  margin-top: 8px;\n  overflow: hidden;\n  border: 1px solid var(--items-border);\n  border-radius: 14px;\n  background: var(--items-surface);\n  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);\n  display: flex;\n  flex-direction: column;\n}\n\n.items-table-toolbar {\n  min-height: 52px;\n  padding: 0 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  border-bottom: 1px solid var(--items-border);\n}\n\n.items-table-toolbar strong {\n  color: var(--items-text);\n  font-size: 13px;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n}\n\n.items-sort,\n.items-delete-selected {\n  padding: 6px 8px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 0;\n  background: transparent;\n  color: var(--items-muted);\n  font: var(--font-weight-regular, 400) 13px/18.2px\n    var(--font-family-primary, \"Lexend\", sans-serif);\n  letter-spacing: 0.065px;\n  cursor: pointer;\n}\n\n.items-sort:hover {\n  color: var(--items-brand);\n}\n\n.items-delete-selected {\n  color: #a3301f;\n  font-weight: 500;\n}\n\n.items-table-scroll {\n  overflow-x: auto;\n}\n\n.items-table {\n  width: 100%;\n  min-width: 830px;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.items-table th,\n.items-table td {\n  padding: 8px 12px;\n  text-align: left;\n  vertical-align: middle;\n  border-bottom: 1px solid var(--items-border);\n}\n\n.items-skeleton-row:hover {\n  background: transparent !important;\n}\n\n.items-skeleton-name {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.items-skeleton-price {\n  margin-left: auto;\n}\n\n.items-table th {\n  height: 44px;\n  background: var(--items-surface-muted);\n  color: var(--items-muted);\n  font-size: 13px;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: 16.9px;\n  letter-spacing: 0.065px;\n}\n\n.items-table td {\n  height: 64px;\n  color: var(--items-text);\n  font-size: 13px;\n  font-weight: var(--font-weight-regular, 400);\n  line-height: 20.2px;\n  letter-spacing: 0;\n}\n\n.items-table tbody tr:hover,\n.items-table tbody tr.selected {\n  background: #f0f8f7;\n}\n\n.items-page.dark .items-table tbody tr:hover,\n.items-page.dark .items-table tbody tr.selected {\n  background: #1b302e;\n}\n\n.items-table th:nth-child(1) {\n  width: 34px;\n}\n\n.items-table th:nth-child(2) {\n  width: 110px;\n}\n\n.items-table th:nth-child(3) {\n  width: 24%;\n}\n\n.items-table th:nth-child(4),\n.items-table th:nth-child(5),\n.items-table th:nth-child(6) {\n  width: 12%;\n}\n\n.items-table th:nth-child(7) {\n  width: 15%;\n}\n\n.items-table th:nth-child(8) {\n  width: 78px;\n}\n\n.items-check-cell {\n  padding-left: 12px !important;\n  padding-right: 2px !important;\n  text-align: center !important;\n}\n\n.items-check-cell input {\n  width: 14px;\n  height: 14px;\n  margin: 0;\n  accent-color: var(--items-brand);\n  cursor: pointer;\n}\n\n.items-code-link,\n.items-code-link:link,\n.items-code-link:visited {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--items-brand);\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n  font-size: 14px;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: 18.2px;\n  letter-spacing: 0.28px;\n  text-transform: uppercase;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.items-code-link:hover {\n  color: var(--items-brand-hover);\n  text-decoration: underline;\n}\n\n.items-code-link,\n.items-name,\n.items-description {\n  display: block;\n  max-width: 100%;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  text-align: left;\n}\n\n.items-name {\n  color: var(--items-text);\n  font-size: 13px;\n  font-weight: var(--font-weight-regular, 400);\n  line-height: 20.2px;\n  letter-spacing: 0;\n}\n\n.items-description {\n  margin-top: 0;\n  color: var(--items-muted);\n  font-size: 11px;\n  font-weight: var(--font-weight-regular, 400);\n  line-height: 15.4px;\n  letter-spacing: 0.11px;\n}\n\n.items-status {\n  min-height: 20px;\n  padding: 3px 7px;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: 14.3px;\n  letter-spacing: 0.11px;\n}\n\n.items-status-active {\n  color: #115a33;\n  background: #edfbf2;\n}\n\n.items-status-inactive,\n.items-status-archived {\n  color: #a3301f;\n  background: #fef2f1;\n}\n\n.items-page.dark .items-status-active {\n  color: #8cd2b2;\n  background: #1b332b;\n}\n\n.items-page.dark .items-status-inactive,\n.items-page.dark .items-status-archived {\n  color: #f3a6a1;\n  background: #382324;\n}\n\n.items-price-cell {\n  text-align: right !important;\n}\n\n.items-table td.items-price-cell {\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n  font-size: 15px;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: 19.5px;\n  letter-spacing: 0;\n}\n\n.items-action-cell {\n  text-align: center !important;\n}\n\n.items-row-menu {\n  position: relative;\n  display: inline-flex;\n}\n\n.items-row-menu > button {\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--items-muted);\n  cursor: pointer;\n}\n\n.items-row-menu > button:hover {\n  color: var(--items-text);\n  background: var(--items-surface-muted);\n}\n\n.items-empty-state {\n  height: 140px !important;\n  color: var(--items-muted) !important;\n  text-align: center !important;\n}\n\n.items-pagination {\n  min-height: 52px;\n  padding: 0 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  border-top: 1px solid var(--items-border);\n  color: var(--items-muted);\n  font-size: 13px;\n  font-weight: var(--font-weight-regular, 400);\n  line-height: normal;\n  letter-spacing: 0;\n}\n\n.items-pagination > div {\n  display: flex;\n  gap: 7px;\n}\n\n.items-pagination button {\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--items-border);\n  border-radius: 6px;\n  background: var(--items-surface);\n  color: var(--items-text);\n  cursor: pointer;\n}\n\n.items-pagination button:hover:not(:disabled) {\n  border-color: var(--items-brand);\n  color: var(--items-brand);\n}\n\n.items-pagination button:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n@media (max-width: 1024px) {\n  .items-page-header h1 {\n    font-size: 28px;\n    line-height: 35px;\n    letter-spacing: -0.42px;\n  }\n\n  .items-page .items-main {\n    margin-left: 0;\n  }\n\n  .items-content {\n    padding: 20px 24px 40px;\n  }\n\n  .items-compact-org {\n    min-height: 42px;\n    margin-bottom: 22px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n  }\n\n  .items-compact-org > button {\n    width: 34px;\n    height: 34px;\n    padding: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--items-border);\n    border-radius: 8px;\n    background: var(--items-surface);\n    color: var(--items-text);\n  }\n\n  .items-compact-org > span {\n    margin-right: auto;\n    color: var(--items-text);\n    font-weight: 600;\n  }\n\n  .items-compact-org > div {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .items-compact-org i {\n    width: 30px;\n    height: 30px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    background: #eef8f7;\n    color: var(--items-brand);\n    font-size: 11px;\n    font-style: normal;\n  }\n\n  .items-compact-org strong,\n  .items-compact-org small {\n    display: block;\n  }\n\n  .items-compact-org strong {\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  .items-compact-org small {\n    margin-top: 1px;\n    color: var(--items-muted);\n    font-size: 10px;\n    font-weight: 400;\n  }\n}\n\n@media (max-width: 640px) {\n  .items-page-header h1 {\n    font-size: 24px;\n    line-height: 30px;\n    letter-spacing: -0.36px;\n  }\n\n  .items-content {\n    padding: 16px 14px 32px;\n  }\n\n  .items-compact-org > div strong,\n  .items-compact-org > div > svg {\n    display: none;\n  }\n\n  .items-page-header {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .items-header-actions {\n    width: 100%;\n  }\n\n  .items-import-button,\n  .items-add-button {\n    flex: 1;\n  }\n\n  .items-controls {\n    align-items: stretch;\n    flex-direction: column;\n    padding: 12px 0;\n  }\n\n  .items-search {\n    width: 100%;\n  }\n\n  .items-filter-wrap {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    width: 100%;\n  }\n\n  .items-filter-select {\n    width: 100%;\n    min-width: 0;\n    max-width: none;\n  }\n\n  .items-filter-button {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .items-filter-panel {\n    width: min(100vw - 28px, 320px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
